import type { InterceptorName } from '../constants';
import { api } from '../fetcher';

const responseIds = new Map<InterceptorName, number>();
const requestIds = new Map<InterceptorName, number>();

type Api = ReturnType<typeof api>;

export function applyResponseInterceptor(name: InterceptorName, ...args: Parameters<Api['interceptors']['response']['use']>) {
    removeResponseInterceptor(name);

    const id = api().interceptors.response.use(...args);

    responseIds.set(name, id);
}

export function removeResponseInterceptor(name: InterceptorName) {
    const id = responseIds.get(name);

    if (id) {
        api().interceptors.response.eject(id);
        responseIds.delete(name);
    }
}

export function applyRequestInterceptor(name: InterceptorName, ...args: Parameters<Api['interceptors']['request']['use']>) {
    removeRequestInterceptor(name);

    const id = api().interceptors.request.use(...args);

    requestIds.set(name, id);
}

export function removeRequestInterceptor(name: InterceptorName) {
    const id = requestIds.get(name);

    if (id) {
        api().interceptors.request.eject(id);
        requestIds.delete(name);
    }
}
